import React from "react";
import { Box, Card } from "@mui/joy";
import type { CardProps } from "@mui/joy";
import type { SxProps } from "@mui/joy/styles/types";
import { gradientTooltipCardShellSx, hrAccentColor } from "../../styles/globalStyles";

export type GradientTooltipCardProps = {
  children: React.ReactNode;
  /** Optional header (accent underline strip, same as ExcursionCardTooltip). */
  header?: React.ReactNode;
  /** Optional footer below body (e.g. chips row). */
  footer?: React.ReactNode;
  /** Merged after shell styles. */
  sx?: SxProps;
  /** Wrapper around `children` (scroll, gap). Defaults to minimal block; omit extra flex when children bring their own layout. */
  bodySx?: SxProps;
} & Omit<CardProps, "children" | "sx" | "variant">;

/**
 * Visual shell shared by ExcursionCardTooltip and other rich tooltips (gradient card, border, shadow).
 */
export default function GradientTooltipCard({
  children,
  header,
  footer,
  sx,
  bodySx,
  ...cardProps
}: GradientTooltipCardProps) {
  return (
    <Card
      component="div"
      variant="plain"
      {...cardProps}
      sx={[gradientTooltipCardShellSx, sx] as SxProps}
    >
      {header != null ? (
        <Box sx={{ borderBottom: `1px solid ${hrAccentColor}`, pb: 1, mb: 1 }}>{header}</Box>
      ) : null}
      <Box sx={[{ minWidth: 0 }, ...(bodySx ? (Array.isArray(bodySx) ? bodySx : [bodySx]) : [])]}>
        {children}
      </Box>
      {footer}
    </Card>
  );
}
